import * as React from "react";
import { graphql } from "gatsby";
import styled from "styled-components";
import PageContainer from "../pageContainer";
import { GatsbyImage } from "gatsby-plugin-image";
import { SectionTitle } from "../typography.js";
import { when } from "../../styles/theme.js";
import { useInView } from "react-intersection-observer";

export const fragment = graphql`
  fragment WorldwideNetworkContent on ContentfulPageSectionWorldwideNetwork {
    title
    description {
      childMarkdownRemark {
        html
      }
    }
    background {
      gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
      description
    }
    highlightLocation1
    highlightLineMiddle1
    highlightNumber1
    highlightLineEnd1
    highlightLocation2
    highlightLineMiddle2
    highlightNumber2
    highlightLineEnd2
    internal {
      type
    }
  }
`;

const Wrapper = styled.section`
  position: relative;
  pointer-events: none;
`;

const Container = styled(PageContainer)`
  padding-top: 15rem;
  padding-bottom: 15rem;
`;

const ContentWrapper = styled.div`
  pointer-events: auto;

  //${when("sm")} {
  //  margin-left: -${(props) => props.theme.gutterWidth.sm / 2}rem;
  //  margin-right: -${(props) => props.theme.gutterWidth.sm / 2}rem;
  //}

  ${when("md")} {
    display: flex;
    margin-left: -${(props) => props.theme.gutterWidth.md / 2}rem;
    margin-right: -${(props) => props.theme.gutterWidth.md / 2}rem;
  }

  ${when("lg")} {
    margin-left: -${(props) => props.theme.gutterWidth.lg / 2}rem;
    margin-right: -${(props) => props.theme.gutterWidth.lg / 2}rem;
  }

  ${when("xl")} {
    margin-left: -${(props) => props.theme.gutterWidth.xl / 2}rem;
    margin-right: -${(props) => props.theme.gutterWidth.xl / 2}rem;
  }

  ${when("xxl")} {
    margin-left: -${(props) => props.theme.gutterWidth.xxl / 2}rem;
    margin-right: -${(props) => props.theme.gutterWidth.xxl / 2}rem;
  }
`;

const HighlightsContainer = styled.div`
  ${when("md")} {
    flex: 1;
    display: flex;
    flex-direction: column;
    //justify-content: flex-end;
    padding-left: ${(props) => props.theme.gutterWidth.md / 2}rem;
    padding-right: ${(props) => props.theme.gutterWidth.md / 2}rem;
    transform: translate(-3rem, -1rem);
    justify-content: center;
  }

  ${when("lg")} {
    padding-left: ${(props) => props.theme.gutterWidth.lg / 2}rem;
    padding-right: ${(props) => props.theme.gutterWidth.lg / 2}rem;
  }

  ${when("xl")} {
    padding-left: ${(props) => props.theme.gutterWidth.xl / 2}rem;
    padding-right: ${(props) => props.theme.gutterWidth.xl / 2}rem;
  }

  ${when("xxl")} {
    padding-left: ${(props) => props.theme.gutterWidth.xxl / 2}rem;
    padding-right: ${(props) => props.theme.gutterWidth.xxl / 2}rem;
  }
`;

const HighlightContainer = styled.div`
  text-align: right;

  ${when("sm")} {
    position: relative;
    top: 1.2rem;
  }
`;

const HighlightLocation = styled.span`
  font-size: 2.4rem;
  line-height: 5rem;
  vertical-align: baseline;
`;

const HighlightLineMiddle = styled.span`
  font-size: 1.8rem;
  line-height: 5rem;
  margin-left: 0.5rem;
  vertical-align: baseline;
`;

const HighlightFigure = styled.span`
  font-size: 5rem;
  font-weight: 700;
  line-height: 5rem;
  margin-left: 0.5rem;
  vertical-align: baseline;
  color: ${(props) => props.theme.colors.darkBlue};
`;

const HighlightLineEnd = styled.span`
  font-size: 2.4rem;
  line-height: 5rem;
  margin-left: 0.5rem;
  vertical-align: baseline;
`;

const ContentContainer = styled.div`
  margin-top: 3rem;

  // ${when("sm")} {
  //   padding-left: ${(props) => props.theme.gutterWidth.sm / 2}rem;
  //   padding-right: ${(props) => props.theme.gutterWidth.sm / 2}rem;
  // }

  ${when("md")} {
    flex: 1;
    margin-top: 0;
    padding-left: ${(props) => props.theme.gutterWidth.md / 2}rem;
    padding-right: ${(props) => props.theme.gutterWidth.md / 2}rem;
  }

  ${when("lg")} {
    padding-left: ${(props) => props.theme.gutterWidth.lg / 2}rem;
    padding-right: ${(props) => props.theme.gutterWidth.lg / 2}rem;
  }

  ${when("xl")} {
    padding-left: ${(props) => props.theme.gutterWidth.xl / 2}rem;
    padding-right: ${(props) => props.theme.gutterWidth.xl / 2}rem;
  }

  ${when("xxl")} {
    padding-left: ${(props) => props.theme.gutterWidth.xxl / 2}rem;
    padding-right: ${(props) => props.theme.gutterWidth.xxl / 2}rem;
  }
`;

const Title = styled(SectionTitle)``;

const Description = styled.div`
  margin-top: 1rem;
  max-width: 60rem;

  ${when("sm")} {
    margin-top: 2rem;
  }
`;

const BackgroundContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: -1;

  // ${when("sm")} {
  //   top: 50%;
  //   transform: translateY(-50%);
  //   height: 250%;
  //   left: -${(props) => props.theme.pageContainerWidth.sm}rem;
  //   right: -${(props) => props.theme.pageContainerWidth.sm}rem;
  // }
  //

  //
  // ${when("lg")} {
  //   left: -16rem;
  //   right: -${(props) => props.theme.pageContainerWidth.lg}rem;
  // }
`;

const BackgroundInnerContainer = styled.div`
  opacity: 0.2;
  width: 150%;
  margin-left: -25%;

  ${when("md")} {
    margin-left: auto;
    margin-right: 0;
    width: 110%;
  }

  ${when("lg")} {
    width: 100%;
    margin-right: -5%;
  }

  ${when("xxl")} {
    width: 82%;
    margin-right: 0;
  }
`;

const WorldwideNetwork = ({ data, setCurrentSection, index }) => {
  const { ref } = useInView({
    onChange: (inView) => {
      if (inView) {
        setCurrentSection(index);
      }
    },
    rootMargin: "-30% 0% -30% 0%",
  });

  return (
    <Wrapper ref={ref}>
      <BackgroundContainer>
        <PageContainer>
          <BackgroundInnerContainer>
            <GatsbyImage
              alt={data.background?.description}
              image={data.background?.gatsbyImageData}
            />
          </BackgroundInnerContainer>
        </PageContainer>
      </BackgroundContainer>
      <Container hasSideBar={true} id={`section-${index}`}>
        <ContentWrapper>
          <HighlightsContainer>
            <HighlightContainer>
              <HighlightLocation>{data.highlightLocation1}</HighlightLocation>
              <HighlightLineMiddle>
                {data.highlightLineMiddle1}
              </HighlightLineMiddle>
              <HighlightFigure>{data.highlightNumber1}</HighlightFigure>
              <HighlightLineEnd>{data.highlightLineEnd1}</HighlightLineEnd>
            </HighlightContainer>
            <HighlightContainer>
              <HighlightLocation>{data.highlightLocation2}</HighlightLocation>
              <HighlightLineMiddle>
                {data.highlightLineMiddle2}
              </HighlightLineMiddle>
              <HighlightFigure>{data.highlightNumber2}</HighlightFigure>
              <HighlightLineEnd>{data.highlightLineEnd2}</HighlightLineEnd>
            </HighlightContainer>
          </HighlightsContainer>
          <ContentContainer>
            <Title>{data.title}</Title>
            <Description
              dangerouslySetInnerHTML={{
                __html: data.description?.childMarkdownRemark.html,
              }}
            />
          </ContentContainer>
        </ContentWrapper>
      </Container>
    </Wrapper>
  );
};
export const worldWideNetworkName = "ContentfulPageSectionWorldwideNetwork";

export default WorldwideNetwork;
